import { AutoRelationshipBase } from './base/auto-relationship-base';

export class AutoRelationship extends AutoRelationshipBase { }